import Asset from './Asset';
import resolveAssetActions from './resolveAssetActions';
import StoreName from '../Shared/Constants/StoreName';

const createAssetStore = state =>
    state.createStore({
        name: StoreName.ASSET,
        model: Asset,
        actions: resolveAssetActions,
        emitOnSubscription: false,
    });

export default createAssetStore;
